module.exports = __webpack_public_path__ + "fonts/demo/tenon-medium.woff";